import { getUniqueArray } from '~/utils/common/utils';
import { useScenarioStore } from '~/widgets/scenario/hooks/use-scenario-store/useScenarioStore';
import { useScreenerEntitiesTags } from '~/widgets/scenario/hooks/use-screener-entities-tags/useScreenerEntitiesTags';

export const useScenarioEntityTags = () => {
  const { filterGroups, scenarioPageEntityTags } = useScenarioStore(state => ({
    filterGroups: state.filterGroups,
    scenarioPageEntityTags: state.scenarioPageEntityTags,
  }));

  const { tagsAddedViaSearch = [] } = scenarioPageEntityTags;
  const filters = filterGroups.ASSET_FILTERS.activeFilterOptions;

  const { data } = useScreenerEntitiesTags({
    filterOptions: filters,
  });
  const filteredEntityTags = data?.entities ?? [];
  const allScenarioEntityTags = [...filteredEntityTags, ...tagsAddedViaSearch];

  return getUniqueArray(allScenarioEntityTags);
};
